import { Divider, Icon } from "@hoylu/client-common";
import React from "react";
import { useSelector } from "react-redux";
import type { AppState } from "../state/root.reducer";
import {
  selectDashboardWorkspaceDetails,
  selectWorkspaceById,
} from "../state/workspaces/workspaces.selector";
import WorkspaceCard from "./cards/WorkspaceCard/WorkspaceCard";
import Styles from "./TeamsSidePanel.module.css";

export const TeamsSidePanel = () => {
  const dashboardWorkspaceDetails = useSelector(
    selectDashboardWorkspaceDetails,
  );
  const firstLiveWorkspaceId = Object.entries(dashboardWorkspaceDetails).find(
    ([, workspaceDetails]) => workspaceDetails.isLive,
  )?.[0];
  const myWorkspaceMetadata = useSelector((state: AppState) =>
    selectWorkspaceById(state, firstLiveWorkspaceId),
  );

  if (!myWorkspaceMetadata) return null;

  return (
    <div className={Styles.teamsSidePanel}>
      <Icon
        disabled
        icon="hoylu-ui-icons-arrowup"
        style={{ color: "var(--global--notification--Color)" }}
      />
      <span className={Styles.shareDescription}>
        {/** biome-ignore lint/style/noJsxLiterals: TODO: needs translation strings */}
        Use share button to share workspace in meeting
      </span>
      <Divider horizontal width="100%" />
      <span className={Styles.selectedWorkspace}>
        {/** biome-ignore lint/style/noJsxLiterals: TODO: needs translation strings */}
        Selected Hoylu Workspace:
      </span>
      <WorkspaceCard
        key={myWorkspaceMetadata.workspaceId}
        myWorkspaceMetadata={myWorkspaceMetadata}
      />
    </div>
  );
};

export default TeamsSidePanel;
